import React, { useCallback, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InsuranceItem from 'src/components/InsuranceItem';
import BottomSheet from 'src/components/BottomSheet';
import Button, { ButtonTypes } from 'src/components/Button';
import './style.scoped.css';
import forwardIcon from 'src/assets/forward_white.svg';
import shieldCheckIcon from 'src/assets/shield_check.svg';
import { confirmQuitFlow } from 'src/utils';
import benefit_1 from 'src/assets/benefit_1.png';
import benefit_2 from 'src/assets/benefit_2.png';
import benefit_3 from 'src/assets/benefit_3.png';
import InsurancePackage from 'src/models/InsurancePackage';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import PopupService from 'src/utils/PopupService';
import documentBlue from 'src/assets/document_blue.svg';
import { gaTrackEvent } from '../../api';
import { BUYING_PROCESS, BUYING_PROCESS_STEP, BUYING_PROCESS_TRACKING } from '../../constants';
import UserInfoService from '../../utils/UserInfoService';
const images = [benefit_1, benefit_2, benefit_3];

interface InsuranceBenefitObserverProps {
  cancerStore?: CancerStore;
}
const InsuranceBenefitObserver = observer(
  ({ cancerStore }: InsuranceBenefitObserverProps) => {
    const history = useHistory();
    const { t } = useTranslation();
    const [choosedPackage, setChoosedPackage] = useState(
      cancerStore?.formInfo?.choosedInsurancePackage ||
        cancerStore.insurancePackages.find((item) => item.defaultSelect == true)
          ?.id
    );
    const [showingBottomSheet, setShowingBottomSheet] = useState(true);

    const _handleCloseBottomSheet = useCallback(() => {
      setShowingBottomSheet(false);
      setChoosedPackage(null);
    }, [setShowingBottomSheet]);

    const _getSelectedPackageInfo = useCallback((): InsurancePackage => {
      if (
        !cancerStore.insurancePackages ||
        cancerStore.insurancePackages.length == 0
      )
        return null;
      return cancerStore.insurancePackages.find(
        (item) => item.id == choosedPackage
      );
    }, [cancerStore, choosedPackage]);

    const _handleContinue = useCallback(() => {
      // setShowingBottomSheet(false);
      if (!choosedPackage) {
        PopupService.instance.current.open({
          visible: true,
          title: t('notification'),
          content: t('please_choose_insurance_package'),
          okTitle: t('close'),
          onOk: () => {
            PopupService.instance.current.close();
          },
          showIcon: false,
        });
        return;
      }
      gaTrackEvent(BUYING_PROCESS_TRACKING,
        BUYING_PROCESS[BUYING_PROCESS_STEP.ChoicePackageInsurance].name,
        UserInfoService.getUserInfo()?.idCardNo ?? "");
        cancerStore.fetchCheckBpTsa(
            choosedPackage,
            +_getSelectedPackageInfo()?.insamountAm,
            history
        );
        // setChoosedPackage(null);
    }, [
      // setShowingBottomSheet,
      history,
      cancerStore,
      choosedPackage,
      _getSelectedPackageInfo,
      t,
    ]);

    const _renderBottomSheet = () => {
      return (
        <BottomSheet
          visible={showingBottomSheet}
          onClose={_handleCloseBottomSheet}
          darkOverlay={false}
        >
          <div className="px-4">
            <div className="benefitRow">
              <img src={shieldCheckIcon} className="w-5 h-5 mr-3" />
              <label className="benefitLabel">{t('cancer_benefit')}:</label>
              <label className="benefitValue">
                &nbsp;{_getSelectedPackageInfo()?.insamountTxt}
              </label>
            </div>
            <div className="benefitRow2">
              <img src={shieldCheckIcon} className="w-5 h-5 mr-3" />
              <div>
                <label className="benefitLabel">{t('live_benefit')}: </label>
                <label className="benefitValue">
                  &nbsp;{_getSelectedPackageInfo()?.survivalTxt}
                </label>
              </div>
            </div>
            <div className="benefitRow pl-8">
              <div className="benefitExplain">
                (Được chi trả thêm khi còn sống sau 24 tháng mắc bệnh ung thư)
              </div>
            </div>
            <div className="benefitRow">
              <img src={shieldCheckIcon} className="w-5 h-5 mr-3" />
              <label className="benefitLabel">{t('insurance_period')}: </label>
              <label className="benefitValue">&nbsp;5 năm</label>
            </div>
            <div className="mb-6 flex items-center">
              <img src={shieldCheckIcon} className="w-5 h-5 mr-3" />
              <label className="benefitLabel">
                {t('issue_new_contract_benefit')}
              </label>
            </div>
            <div className="flex flex-row mb-4">
              <Button
                text={t('continue')}
                buttonType={ButtonTypes.primaryFilled}
                extraClassName="w-full"
                onClick={_handleContinue}
                rightIcon={<img src={forwardIcon} className="w-6 h-6 ml-2" />}
              />
            </div>
          </div>
        </BottomSheet>
      );
    };

    const _handleClose = () => {
      confirmQuitFlow(history);
    };

    const _handleChoosePackage = (item: InsurancePackage) => {
      if (choosedPackage != item.id) {
        setChoosedPackage(item.id);
        setTimeout(() => {
          setShowingBottomSheet(true);
        });
      } else {
        setShowingBottomSheet(false);
        setChoosedPackage(null);
      }
    };

    const _handleBack = () => {
      history.goBack();
      cancerStore.updateFormInfo({ choosedInsurancePackage: null });
    };

    const _handleViewTerm = (e) => {
      console.log('View Term');
      e.stopPropagation();
      cancerStore.updateFormInfo({ choosedInsurancePackage: choosedPackage });
      history.push('/buy-insurance/cancer/term-and-condition');
    };

    return (
      <div className="screenContainerWithoutButton bg-background">
        <Toolbar
          title={t('insurance_benefit')}
          type="normal"
          showClose={true}
          onClose={_handleClose}
          onBack={_handleBack}
        />
        {_renderBottomSheet()}
        <div className="max-w-md mx-auto p-4 pb-72 screenScrollContainerWithoutButton">
          {cancerStore.insurancePackages.map((item, index) => {
            return (
              <div className="mb-4" key={item.id}>
                <InsuranceItem
                  data={item}
                  image={images[index % 3]}
                  isChoosed={choosedPackage === item.id}
                  onChoose={_handleChoosePackage}
                />
              </div>
            );
          })}
          <div
            className="viewTermContainer smallTitlePrimary"
            onClick={_handleViewTerm}
          >
            <img src={documentBlue} className="documentIcon" />
            {t('view_term')}
          </div>
        </div>
      </div>
    );
  }
);

const InsuranceBenefit = () => (
  <InsuranceBenefitObserver cancerStore={cancerStore} />
);
export default InsuranceBenefit;
